import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import money from 'v-money3'
import VueTheMask from 'vue-the-mask'
// import './registerServiceWorker'
import { router } from './router'
import store from './store'
import { QuillEditor, Quill } from '@vueup/vue-quill'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

import '@/styles/_global.scss'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import 'drawflow/dist/drawflow.min.css'
import './utils/QuillSpacing'

import excel from 'vue-excel-export'

// Registrar fontes customizadas no Quill (deve ser antes de criar a app)
const Font = Quill.import('formats/font')
Font.whitelist = [
  '', // sans-serif (padrão)
  'serif',
  'monospace',
  'arial',
  'timesnewroman',
  'couriernew',
  'verdana',
  'georgia',
  'trebuchetms',
  'comicsansms'
]
Quill.register(Font, true)

document.title = "Cosmos " + document.location.hostname.split('.')[0];

var app = createApp(App)
var pinia = createPinia()
app.use(Quasar, quasarUserOptions)
app.component('QuillEditor', QuillEditor)
app.use(store)
app.use(router)
app.use(pinia)
app.use(excel)
app.use(money)
app.use(VueTheMask)
app.mount('#app')
